export default {"src":"/_next/static/media/Line 1322.d590fccc.svg","height":133,"width":20,"blurWidth":0,"blurHeight":0};